import { useState } from "react";
import TeamSelection from "./components/TeamSelection";
import GameLobby from "./components/GameLobby";
import GameRoom from "./components/GameRoom";
import GameBoard from "./components/GameBoard";

function App() {
  const [team, setTeam] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [gameStarted, setGameStarted] = useState(false);

  if (!team) {
    return <TeamSelection setTeam={setTeam} />;
  } 
  if (!gameId) {
    return <GameLobby team={team} setGameId={setGameId} />;
  }
  if (!gameStarted) {
    return <GameRoom gameId={gameId} team={team} setGameStarted={setGameStarted} />;
  }
  
  return <GameBoard gameId={gameId} player={team} />;
}

export default App;
